<template>
  <scroll-center-dialog v-model="opened" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-text-field :error="hasError('started')"
                  :error-messages="getError('started')"
                  label="Дата начала"
                  outlined
                  class="pt-3"
                  v-model="value.started"
                  type="time"
    ></v-text-field>
    <v-text-field :error="hasError('date_ended')"
                  :error-messages="getError('date_ended')"
                  label="Максимум записавшихся"
                  outlined
                  v-model="value.max_visitors"

    ></v-text-field>
    <v-alert type="error" v-if="hasError('non_field_errors')">
      {{ String(getError('non_field_errors')) }}
    </v-alert>
    <v-alert type="error" v-if="hasError('detail')">
      {{ String(getError('detail')) }}
    </v-alert>
    <v-alert type="error" v-if="hasError('error')">
      {{ String(getError('error')) }}
    </v-alert>
  </scroll-center-dialog>


</template>

<script>
import {loadData, makeGetRequest} from "@/helper/requests";
import urls from '@/urls/helper.js'
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog.vue";
import {mapActions} from "vuex";
import FormErrorsMixin from "@/mixins/FormErrorsMixin";

export default {
  name: "Courses",
  components: {ScrollCenterDialog},
  mixins: [FormErrorsMixin],
  props: {
    opened: Boolean,
    edit: Boolean,
    docs_data: Object,
  },
  data() {
    return {
      value: {
        id: this.docs_data.id || undefined,
        max_visitors: this.docs_data.max_visitors || undefined,
        started: this.docs_data.started || undefined,
      },
    }
  },
  computed: {
    form_title() {
      return this.value.id ? 'Редактировать' : 'Добавить'
    },
  },
  methods: {
    ...mapActions({
      createData: 'intervals/createInterval',
      changeData: 'intervals/changeInterval',
      detailData: 'intervals/loadIntervalDetail'
    }),
    save() {
      if (this.docs_data.id) {
        this.changeData({
          id: this.value.id,
          date: this.$route.params.date,
          data: this.value,
          finalizer: (val) => {
            this.$emit('close', val)
          },
          catcher: (val) => {
            this.mapErrors(val)
          },
        })
      } else {
        this.createData({
          data: this.value,
          date: this.$route.params.date,
          finalizer: (val) => {
            this.$emit('close', val)
          },
          catcher: (val) => {
            this.mapErrors(val)
          },
        })
      }
    },
    close() {
      this.$emit('close', false)
    },
  },
  created() {
    if (this.docs_data.id) {
      this.detailData({
        id: this.docs_data.id,
        date: this.$route.params.date,
        finalizer: (val) => {
          this.value = JSON.parse(JSON.stringify(val))
        },
        catcher: (val) => {
          this.mapErrors(val)
        },
      })
    }
  }
}
</script>

<style scoped>
</style>
